import { type Reduction, reductionValues } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import { NO_REDUCTION } from './reduction.js';

/**
 * Calculate the sum of reductions in the definition.
 *
 * @param definition Product definition
 * @returns Max reduction sum
 */
export function getDefinitionReductionSum(definition: Definition): Reduction {
  const sum = definition.reduction.reduce((sum, r) => r + sum, NO_REDUCTION);

  try {
    return reductionValues.parse(sum);
  } catch {
    return NO_REDUCTION;
  }
}
